import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import TooltipMUI from '@material-ui/core/Tooltip';
const styles = (theme) => createStyles({
    tooltip: {
        padding: '0.5em',
        borderRadius: theme.common.borderRadius.default,
        backgroundColor: theme.color.grey.darkest,
        color: theme.color.font.light,
        lineHeight: theme.font.lineHeight.mediumBig,
        boxShadow: theme.common.shadow.default,
        opacity: 1,
        textAlign: 'left',
        fontSize: theme.font.size.mediumSmall,
    },
});
const TitleTooltip = (props) => {
    const { classes, children, testId = 'TitleTooltip', disableHoverListener, ...other } = props;
    return (React.createElement(TooltipMUI, Object.assign({ "data-testid": `${testId}`, classes: { tooltip: classes.tooltip }, disableHoverListener: disableHoverListener }, other), children));
};
const ComposedTitleTooltip = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    placement: 'right',
}))(TitleTooltip);
ComposedTitleTooltip.displayName = 'TitleTooltip';
export default ComposedTitleTooltip;
//# sourceMappingURL=TitleTooltip.js.map